<template>
  <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
    <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
      <el-col class="flex-box al-c" :span="4">
        <el-button type="primary" @click="initPage">查询</el-button>
        <el-button type="primary" @click="addFn">添加</el-button>
      </el-col>
    </Sift>

    <div class="table-con">
      <el-table class="w100 mt20 table"   header-row-class-name="table-head"
                row-class-name="cu-p" stripe :data="list">
        <el-table-column align="center" label="序号" width="50px">
          <template slot-scope="scope">
            {{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="主题名称"></el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
        <el-table-column align="center" prop="updateTime" label="更新时间"></el-table-column>
        <el-table-column align="center" prop="refuseIP" label="操作">
          <template slot-scope="scope">
            <div class="to-use">
              <span class="info" @click="editFn(scope.row.id, scope.row.name)">编辑</span>
              <span class="danger" @click="deleteFn(scope.row.id, scope.row.name)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination background @size-change="changeSize"
                     @current-change="changePage"
                     :current-page="paramSearch.current"
                     :page-sizes="pageSizes"
                     :page-size="paramSearch.size"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"
                      ></el-pagination>
    </div>

    <!-- 详情、新增 -->
    <ThemeDialog ref="themeDialog" @saveSuccess="saveSuccess"/>

  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import ThemeDialog from "@/components/management/theme/ThemeDialog";
import { getSubjectList,getSubjectInfo, handleSubjectDelete} from '@/api/managementCenter/themeManage';

export default {
  name: "Theme",
  components: {
    Sift,
    ThemeDialog
  },
  props: [],
  data() {
    return {
      loading: false,
      siftData : [
          {
              type: "text",
              key: "name",
              label: "主题名称",
              placeholder: "请输入主题名称",
              default: ""
          }
      ],
      list: [],
      pageSizes:[10, 20, 30, 50, 100],
      paramSearch:{
          current:1,
          size:10,
          name:''
      },
      total: 0
    };
  },
  computed: {},
  created() {},
  mounted() {
      this.getListFn();
  },
  methods: {
    // 获取查询列表
    getListFn () {
        this.loading = true;
        getSubjectList(this.paramSearch).then(({data})=> {
            this.loading = false;
           if(data.code == 0){
               this.list = data.data.records || []
               this.total = data.data.total;
           }
      })
      .catch(() => {
        this.loading = false;
      });
    },

    // 添加
    addFn() {
        this.$refs.themeDialog.dialogShow('add');
    },

    // 删除
    deleteFn (id, name) {
      this.$confirm( "是否确定删除" + name + " ?", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          this.deleteHttp(id,name)

      }).catch(() => {
          this.$message.info( "已取消删除" );

      });
    },
    deleteHttp(id,name){
        this.loading = true;
        // 删除接口
        handleSubjectDelete(id).then( ({data}) => {
            this.loading = false;
            if(data.code == 0){
                this.$message.success( name + "删除成功!" );
                this.getListFn();
            }else{
                this.$message.warning( data.msg||"删除失败！" );
            }
        }).catch(() => {
                this.loading = false;
                this.$message.error( "删除异常!" );
            });
    },
    // 详情
    editFn (id, name) {
        this.loading = true;
        getSubjectInfo(id).then(({data})=>{
            this.loading = false;
            if(data.code == 0){

                this.$refs.themeDialog.dialogShow('edit',data.data);

            }else{
                this.$message.warning( data.msg||"获取主题信息失败！" );
            }
        }).catch(err=>{
            this.loading = false;
        })


    },

    // 默认页面数据
    initPage() {
        this.paramSearch={
            ...this.paramSearch,
            ...this.$refs.needSift.getValue(),
            current:1
        }
      this.getListFn();
    },

    // 条数
    changeSize(value) {
        this.paramSearch.size=value;
        this.paramSearch.current=1;
        this.getListFn();
    },
    // 翻页
    changePage(value) {
      this.paramSearch.current=value;
      this.getListFn();
    },
      saveSuccess(){
          this.getListFn();
      }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped  lang="less">
  @import "../../../assets/css/handleBtn.less";
  /deep/.el-table {
    width: 100%;
    .el-table__body-wrapper {
      max-height: calc(100vh - 300px);
      overflow-y: auto;

    }
  }
</style>
